import { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { adminApi, formatApiErrorDetail } from "../lib/adminApi";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    document.title = "Admin Sign In | Vaskion Technologies";
    adminApi.get("/auth/me").then(() => navigate("/admin/dashboard")).catch(() => {});
  }, [navigate]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await adminApi.post("/auth/login", { email, password });
      navigate("/admin/dashboard");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen items-center justify-center bg-brand-surface px-4">
      <div className="w-full max-w-md border border-border bg-white p-8 shadow-sm sm:p-10">
        <div className="flex items-center gap-3">
          <ShieldCheck className="h-8 w-8 text-brand-red" aria-hidden="true" />
          <div>
            <h1 className="text-xl font-semibold text-brand-graphite">Admin Dashboard</h1>
            <p className="text-sm text-brand-grey">Vaskion Technologies Private Limited</p>
          </div>
        </div>
        <form onSubmit={onSubmit} className="mt-8 space-y-5" data-testid="admin-login-form">
          <div>
            <label htmlFor="admin-email" className="field-label">Email</label>
            <input
              id="admin-email"
              type="email"
              required
              autoComplete="username"
              className="field-input"
              placeholder="admin@vaskiontech.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              data-testid="admin-login-email-input"
            />
          </div>
          <div>
            <label htmlFor="admin-password" className="field-label">Password</label>
            <input
              id="admin-password"
              type="password"
              required
              autoComplete="current-password"
              className="field-input"
              placeholder="Your password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="admin-login-password-input"
            />
          </div>
          {error && (
            <p className="border-l-2 border-brand-red bg-brand-surface p-3 text-sm text-brand-graphite" role="alert" data-testid="admin-login-error">
              {error}
            </p>
          )}
          <button type="submit" className="btn-primary w-full" disabled={loading} data-testid="admin-login-submit-button">
            {loading ? "Signing in…" : "Sign In"}
          </button>
        </form>
        <p className="mt-6 text-center text-sm text-brand-grey">
          <Link to="/admin/reset" className="font-medium text-brand-red underline underline-offset-2" data-testid="admin-forgot-password-link">
            Set up or reset your password
          </Link>
        </p>
      </div>
    </div>
  );
}
